<template>
<v-card v-if="isSet">
  <v-card-title class="grey lighten-3 blue-grey--text text--darken-4"><span class="title">{{ printTitle }}</span></v-card-title>
  <v-divider></v-divider>
  <v-card-text>
    <Filer v-if="hasMedia"
      :items="getMedia"
      :showOnlyItems="true"
      :permits="{ select: false }"
    />
    <p v-else class="body-1">関連書類はございません。</p>
  </v-card-text>
</v-card>
</template>

<script>
import Filer from '@/components/filers/client'
export default {
  name: 'userFlightPoster',
  props: [
    'item'
  ],
  components: {
    Filer
  },
  data () {
    return {
      config: {
        status: {
          active: false,
          loading: false
        }
      }
    }
  },
  methods: {
  },
  computed: {
    isSet () {
      return this.$props.item
    },
    isActive () {
      return this.config.status.active
    },
    isLoading () {
      return this.config.status.loading
    },
    hasMedia () {
      return (this.$props.item.media && this.$props.item.media.length)
    },
    printTitle () {
      return this.$props.item.title || ''
    },
    getMedia () {
      return this.$props.item.media || []
    }
  }
}
</script>
<style lang=“scss”>
</style>
